<script>
import { hydrateWhenVisible } from 'vue-lazy-hydration'
import AppTitle from '@theme/components/atom/AppTitle'
import ArticleList from '@theme/components/content/ArticleList'
import ArticleMenu from '@theme/components/content/ArticleMenu'
import ArticleTagList from '@theme/components/content/ArticleTagList'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Container from '@theme/components/utils/Container'
import ContentHeader from '@theme/components/content/ContentHeader'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import MenuHorizontal from '@theme/components/content/MenuHorizontal'
import PaginatedMixin from '~/mixins/PaginatedMixin'

export default {
  components: {
    AppTitle,
    ArticleList,
    ArticleMenu,
    ArticleTagList,
    MenuHorizontal,
    Breadcrumbs,
    Container,
    ContentHeader: hydrateWhenVisible(ContentHeader),
    LayoutBase,
  },
  mixins: [ImageUrlMixin, PaginatedMixin],
  props: {
    initArticles: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      articles: this.initArticles,
    }
  },
}
</script>
